// extracted by mini-css-extract-plugin
export default {"root":"_1aWSX","content":"_3zh42"};